'use client'
import { isPageLoaderOpenAtom } from '@/lib/atoms/atoms'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import Slide from '@mui/material/Slide'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

function PageLoader({ outLoading }) {
  const isLoading = useAtomValue(isPageLoaderOpenAtom)
  const tPageLoader = useTranslations('pageLoader')
  return (
    <>
      <Backdrop sx={{ zIndex: 9999 }} open={!!outLoading || isLoading} />
      <Slide in={!!outLoading || isLoading}>
        <Stack
          position={'fixed'}
          justifyContent={'center'}
          alignItems={'center'}
          sx={{ inset: 0 }}
          zIndex={9999}
          gap={2}
          direction={'row'}
        >
          <CircularProgress size={42} color='secondary' />
          <Typography variant='h4' color='secondary'>
            {tPageLoader('text')}
          </Typography>
        </Stack>
      </Slide>
    </>
  )
}

export default PageLoader
